import styled, { css } from 'styled-components'

interface ContainerProps {
  color?:
    | 'white'
    | 'orange'
    | 'red'
    | 'blue'
    | 'darkBlue'
    | 'green'
    | 'darkGreen'
    | 'pink'
    | 'purple'
  size?: 'large' | 'normal'
  gradientDirection?: 'left' | 'right'
  displayed?: boolean
}

// const getGradientAndShadow = (
//   color1: string,
//   color2: string,
//   direction: ContainerProps['gradientDirection'],
// ) => css`
//   ${direction === 'right'
//     ? css`
//         background-image: linear-gradient(60deg, ${color1}, ${color2});
//       `
//     : css`
//         background-image: linear-gradient(60deg, ${color2}, ${color1});
//       `}
//   box-shadow: 0px 6px 8px rgba(101, 101, 101,0.2);
// `

const colorTypesVariation = {
  orange: {
    left: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #f39500;
    `,
    right: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #f39500;
    `,
  },
  red: {
    left: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #c50022;
    `,
    right: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #c50022;
    `,
  },
  blue: {
    left: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #21a0d2;
    `,
    right: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #21a0d2;
    `,
  },
  darkBlue: {
    left: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #004a96;
    `,
    right: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #004a96;
    `,
  },
  green: {
    left: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #65ac1e;
    `,
    right: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #65ac1e;
    `,
  },
  darkGreen: {
    left: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #00793a;
    `,
    right: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #00793a;
    `,
  },
  pink: {
    left: css`
      color: ${({ theme }) => theme.colors.text};
      background-color: #e49f92;
    `,
    right: css`
      color: ${({ theme }) => theme.colors.text};
      background-color: #e49f92;
    `,
  },
  purple: {
    left: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #7a71ef;
    `,
    right: css`
      color: ${({ theme }) => theme.colors.textSecondary};
      background-color: #7a71ef;
    `,
  },
  white: {
    left: css`
      color: ${({ theme }) => theme.colors.text};
      background-color: #ffffff;
      box-shadow: 0px 6px 8px rgba(101, 101, 101, 0.09);
      border: 1px solid #eaeaea;
    `,
    right: css`
      color: ${({ theme }) => theme.colors.text};
      background-color: #ffffff;
      box-shadow: 0px 6px 8px rgba(101, 101, 101, 0.09);
      border: 1px solid #eaeaea;
    `,
  },
}

export const Container = styled.div<ContainerProps>`
  ${props =>
    colorTypesVariation[props.color || 'white'][
      props.gradientDirection || 'right'
    ]}

  width: ${props => (props.size === 'large' ? '100%' : '160px')};
  min-height: ${props => (props.displayed ? '85px' : '0px')};
  height: ${props => (props.displayed ? '100%' : '0px')};
  padding: ${props => (props.displayed ? '15px' : '0px')};

  position: relative;
  border-radius: 4px;
  opacity: ${props => (props.displayed ? 1 : 0)};

  pointer-events: ${props => (props.displayed ? 'all' : 'none')};
  overflow: none;

  transition: 0.2s all ease-in-out;

  @media screen and (max-width: 766px) {
    width: ${props => (props.size === 'large' ? '100%' : '200px')};
  }
`
